import { FormGroup, Label, Paragraph } from './styles/common';
import getFieldId from './getFieldId';

const DEFAULT_PHONE_HELPER_TEXT = 'Inserire un numero di telefono reale.';

const resolveHelperText = (helperText, registration, name) => {
  if (helperText !== undefined) return helperText;
  const fieldName = registration?.name ?? name;
  if (fieldName === 'phone') return DEFAULT_PHONE_HELPER_TEXT;
  return null;
};

// v2 of formInputs/FormInputText — same prop contract (registration OR
// value/onChange, error, valid, label, ...), restyled for touch/mobile.
export function FormInputText({
  label,
  paragraph,
  type,
  placeholder,
  min,
  max,
  registration,
  valid,
  error,
  value,
  onChange,
  inputId,
  onWheel,
  trim = true,
  classNameInput,
  disabled = false,
  helperText,
  name,
  hint,
}) {
  const resolvedHelperText = resolveHelperText(helperText, registration, name);
  const fieldId = getFieldId(inputId, registration, name);
  const errorId = error ? `${fieldId}-error` : undefined;

  if (registration === undefined) {
    const handleChange = (e) => {
      onChange(trim ? e.target.value.trim() : e.target.value);
    };

    return (
      <FormGroup>
        {label !== undefined && <Label htmlFor={fieldId}>{label}</Label>}
        {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
        <input
          placeholder={placeholder}
          id={fieldId}
          className={`form-control ${classNameInput || ''} ${error ? 'is-invalid' : ''
          } ${valid ? 'is-valid' : ''}`}
          type={type}
          name={name}
          min={min}
          max={max}
          onWheel={onWheel}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={errorId}
        />
        <div className="invalid-feedback" id={errorId}>{error}</div>
        {hint && <p className="form-input-hint">{hint}</p>}
        {resolvedHelperText && (
          <small className="form-text d-block ">{resolvedHelperText}</small>
        )}
      </FormGroup>
    );
  }

  return (
    <FormGroup>
      {label !== undefined && <Label htmlFor={fieldId}>{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
      <input
        id={fieldId}
        placeholder={placeholder}
        className={`form-control ${classNameInput || ''} ${error ? 'is-invalid' : ''
        } ${valid ? 'is-valid' : ''}`}
        type={type}
        onWheel={onWheel}
        min={min}
        max={max}
        {...registration}
        disabled={disabled}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={errorId}
      />
      <div className="invalid-feedback" id={errorId}>{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
      {resolvedHelperText && (
        <small className="form-text d-block">{resolvedHelperText}</small>
      )}
    </FormGroup>
  );
}
